// Generated by CoffeeScript 1.6.3
(function() {
  rjm.util.deferredClosureQueue = (function() {
    var call, closureCache, publicVars, queue;
    call = function(calledPosition) {
      var index;
      index = 0;
      while (index < queue.length) {
        if (queue[index] !== undefined) {
          if (!queue[index].hasRun) {
            queue[index].hasRun = true;
            queue[index].func();
          } else {
            if (calledPosition === index) {
              return null;
            }
          }
        }
        index++;
      }
      return null;
    };
    queue = [];
    closureCache = [];
    publicVars = {
      setAndReturnClosure: function(options) {
        var closure, position, predicate;
        if (!options.hasOwnProperty("closure") || !options.hasOwnProperty("queuePosition")) {
          throw "Invalid Arguments - deferredClosureQueue::setClosure";
        }
        closure = options.closure;
        position = options.queuePosition;
        predicate = null;
        if (options.hasOwnProperty("predicate")) {
          predicate = options.predicate;
        }
        closureCache[position] = function() {
          queue[position] = {
            hasRun: false,
            func: closure
          };
          if (predicate === null || predicate(arguments)) {
            return _.defer(function() {
              return call(position);
            });
          }
        };
        return closureCache[position];
      },
      getClosure: function(position) {
        return closureCache[position];
      }
    };
    return publicVars;
  })();

  rjm.util.deferredClosureQueueOrder = (function() {
    return {
      CHART_PREVIEW: 0
    };
  })();

}).call(this);
